import { useCallback } from 'react';
import { isQueryFinishedLoading } from '@/utils/isQueryFinishedLoading';
import { useAllTeamsList } from './useAllTeamsList';

export const useTeamHelpers = () => {
  const query = useAllTeamsList();

  const getTeamName = useCallback(
    (id: string) => {
      if (isQueryFinishedLoading(query) === false) {
        throw new Error('Team list is not loaded yet');
      }
      const found = query.data?.find((team) => team.id === id);

      if (!found) throw new Error(`Team with id ${id} not found in team list`);
      return found.teamName;
    },
    [query]
  );

  return { getTeamName, teamsQuery: query };
};
